// "Connect your CRM" card under the navigation bar, for signed-in members with no CRM connected yet.
// In the app only (no texts or emails, Austin 10/27). Dismissible: "Not now" hides it for 7 days on this
// device, "I don't use a CRM" for a year. Connecting opens the same flow as the coaching board tile.
import React, { useEffect, useState } from 'react';
import { getRequest } from '../../helpers/httpHandler2';
import { statV2Open } from './api';
import { ConnectCrm } from './StatTrackerTile';
import classes from './CrmPrompt.module.css';

const KEY = 'cwu.crmPrompt.hiddenUntil';
const DAY = 86400000;
const hiddenNow = () => {
  try {
    return Number(window.localStorage.getItem(KEY) || 0) > Date.now();
  } catch {
    return false;
  }
};
const hideFor = (days: number) => {
  try {
    window.localStorage.setItem(KEY, String(Date.now() + days * DAY));
  } catch {
    // storage blocked: it simply shows again next visit
  }
};

const CrmPrompt = () => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    if (hiddenNow() || !localStorage.getItem('CWAuthToken')) return;
    statV2Open()
      .then((on) => (on ? getRequest('/api/account/connections') : null))
      .then((list: { category: string; status: string }[] | null) => {
        if (!alive || !list) return;
        const connected = list.some((c) => c.category === 'crm' && c.status !== 'not_connected');
        setShow(!connected);
      })
      .catch(() => alive && setShow(false));
    return () => {
      alive = false;
    };
  }, []);

  if (done) {
    return (
      <div className={classes.bar} role='status'>
        <span className={classes.text}><b>{done} is connected.</b> Your Stat Tracker starts filling in within a few minutes.</span>
        <button className={classes.link} onClick={() => setDone(null)}>Close</button>
      </div>
    );
  }
  if (!show) return null;
  return (
    <div className={classes.bar} role='region' aria-label='Connect your CRM'>
      <span className={classes.text}>
        <b>Stop typing your numbers.</b> Connect your CRM once and your Stat Tracker fills in every morning, so your coach always sees where you are.
      </span>
      <span className={classes.actions}>
        <button className={classes.gold} onClick={() => setOpen(true)}>Connect your CRM</button>
        <button className={classes.link} onClick={() => { hideFor(7); setShow(false); }}>Not now</button>
        <button className={classes.link} onClick={() => { hideFor(365); setShow(false); }}>I don't use a CRM</button>
      </span>
      {open && <ConnectCrm onClose={() => setOpen(false)} onConnected={(name) => { setOpen(false); setShow(false); setDone(name); }} />}
    </div>
  );
};

export default CrmPrompt;
